/* 
  App.js: Main application file for the Nisa and Sabir Foundation website
  @authored by Miriam Khan 
  @date 11-2-24
*/

import { Routes, Route, Navigate } from "react-router-dom"; 
import ScrollToTop from "./components/ScrollToTop";
import './App.css'; 

import Header from "./components/Header"; 
import Footer from "./components/Footer"; 
/*  About Us */
import HomePage from "./pages/home/HomePage"; 
import Projects from "./pages/Projects";
/*  Donate Now */
import GetInvoled from "./pages/GetInvolved";
import Donate from "./pages/Donate"; 
/*  Contact Us */
import Contact from "./pages/Contact"; 

const App = () => {
  return (
    <div className="app">
      <ScrollToTop />
      <Header />

      <main className="main-content">
        <Routes>
          <Route path="/" element={<Navigate to="/homepage" replace />} />
          <Route path="/homepage" element={<HomePage />} />
          <Route path="/our-projects" element={<Projects />} />
          <Route path="/get-involved" element={<GetInvoled />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
};

export default App;
